import type { ComponentProps } from 'react';
import { useFormikContext } from 'formik';
import type { ERPJobFormValues } from '@/raptorjob/presentation/ERPJobValidationSchema';
import { ERPJobResourcesStep } from '../ERPJobSteps/ERPJobResourcesStep';

export type ERPJobCreateResourcesStepProps = ComponentProps<typeof ERPJobResourcesStep>;

/**
 * Resources step for New Job: reads customer/job site from Formik context and passes
 * them to ERPJobResourcesStep which handles compliance internally.
 */
export function ERPJobCreateResourcesStep(props: ERPJobCreateResourcesStepProps) {
  const { values } = useFormikContext<ERPJobFormValues>();
  const customerId = values.customerId != null && values.customerId > 0 ? values.customerId : undefined;
  const jobSiteId = values.jobSiteId != null && values.jobSiteId > 0 ? values.jobSiteId : undefined;

  return <ERPJobResourcesStep {...props} customerId={customerId} jobSiteId={jobSiteId} />;
}
